var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSoundMuted = function SvgSoundMuted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3607_37260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 9C13.125 7.3775 12.19 5.98417 10.8333 5.30583V7.33167L13.0792 9.5775C13.1067 9.39417 13.125 9.20167 13.125 9ZM15.4167 9C15.4167 9.86167 15.2333 10.6683 14.9217 11.42L16.3058 12.8042C16.9108 11.6675 17.25 10.375 17.25 9C17.25 5.07667 14.5092 1.795 10.8333 0.960833V2.84917C13.4825 3.6375 15.4167 6.09417 15.4167 9ZM1.91417 0.75L0.75 1.91417L5.08583 6.25H0.75V11.75H4.41667L9 16.3333V10.1642L12.8958 14.06C12.2817 14.5367 11.5942 14.9125 10.8333 15.1417V17.03C12.0983 16.7458 13.2442 16.1592 14.2158 15.3708L16.0858 17.25L17.25 16.0858L9 7.83583L1.91417 0.75ZM9 1.66667L7.08417 3.5825L9 5.49833V1.66667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3607_37260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSoundMuted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sound-muted.59f94baf.svg";
export { ForwardRef as ReactComponent };